<!-- Project settings -->
<div class="fdm-floatbar" *ngIf="!loading">
  <div class="fdm-sidebar-header fdm-sidebar-header-primary fdm-buttons fdm-shadow clearfix">

    <li class="fdm-linked fdm-options-button pointer" (click)="cancel()">
      <fa-icon icon="times"></fa-icon>
    </li>
    <h2>{{ 'PROJECT.SETTINGS' | translate }}</h2>
  </div>

  <div class="fdm-sidebar-body fdm-sidebar-content">

    <!-- Project name -->
    <mat-form-field class="example-full-width" *ngIf="project">
      <input matInput placeholder="{{ 'PROJECTS.NAME' | translate }}" [(ngModel)]="project.name">
    </mat-form-field>

    <!-- Measurement unit: meters/feet -->
    <div class="fdm-choice-box">
      <label>{{ 'PROJECT.SETTING.MEASUREMENT_UNIT' | translate }}</label>
      <div>
        <mat-radio-group class="this-radio-group" (change)="saveMeasurementUnit()" [(ngModel)]="feet_Meter">
          <mat-radio-button class="this-radio-button" [value]="Feet">{{ 'PROJECT.SETTING.FEET' | translate }}</mat-radio-button>
          <mat-radio-button class="this-radio-button" [value]="Meter">{{ 'PROJECT.SETTING.METER' | translate }}</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

     <!-- Number precision (decimal places) -->
    <div class="fdm-choice-box">
      <div translate class="fdm-line-label">PROJECT.SETTING.NUMBER_PRECISSION</div>
      <input type="number" min="1" max="5" value="2"  style="width: 40px;" (change)="changeNumberPrecission()" [(ngModel)]="number_precission" />
    </div>

    <!-- EPSG code-->
    <div class="fdm-choice-box">
      <label>{{'MAP.PHOTOGRAM.SELECTED_EPSG_CODE' | translate }}</label>
      <div>
        <span *ngIf="selectedEPSGCode"> {{selectedEPSGCode.name}} </span>
        <span *ngIf="!selectedEPSGCode"> {{ 'MAP.PHOTOGRAM.NONE_SELECTED' | translate }} </span>
      </div>
      <button mat-stroked-button color="primary" (click)="selectEPSGCode()" > {{'MAP.PHOTOGRAM.SELECT_EPSG_CODE' | translate }} </button>
    </div>

    <!-- View-->
    <div class="fdm-choice-box">
      <label>{{ 'GENERIC.VIEW' | translate }}</label>
      
        <!-- <div>
        <mat-slide-toggle (change)="changeContextMenu($event)" [(checked)]="viewContextMenu">{{ 'MAP.CONTEXT_MENU' | translate }}</mat-slide-toggle>
      </div>-->
      <!-- <div *ngIf="viewContextMenu" style="margin-left:20px;">
          <mat-slide-toggle (change)="changeContextMenuFloating($event)" [(checked)]="viewContextMenuFloating">{{ 'MAP.FLOATING' | translate }}</mat-slide-toggle>
        </div>-->
                <!-- <div> <mat-slide-toggle (change)="changeViewLibraryTab($event)" [(checked)]="viewLibraryTab">{{ 'MAP.LIBRARY_TAB' | translate }}</mat-slide-toggle>
      </div> -->
      <!-- <div>
        <mat-slide-toggle (change)="changeViewPhotoBucket($event)" [(checked)]="viewPhotoBucket">Photo gallery popup</mat-slide-toggle>
    </div> -->

      <div>
        <!-- Background map -->
        <mat-slide-toggle (change)="showBaseModel($event)" [(checked)]="baseModel">{{ 'MAP.BACKGROUND_MAP' | translate }}</mat-slide-toggle>
      </div>
      <div>

         <!-- Show globe -->
        <mat-slide-toggle (change)="showGlobeOnCesium($event)" [(checked)]="showGlobe">{{ 'MAP.SHOW_GLOBE' | translate }}</mat-slide-toggle>
      </div>
    </div>

        <!-- <div class="fdm-choice-box">
      <label>{{ 'GENERIC.OTHER' | translate }}</label>
      <div>
          <mat-checkbox [(ngModel)]="resetLastLocation">{{ 'PROJECTS.RESET_LOCATION' | translate }}</mat-checkbox>
      </div> 
    </div> -->

    <div>
      <!-- Save settings-->
      <button mat-raised-button class="ml-1" color="primary" (click)="save()" id="save-settings">{{ 'GENERIC.SAVE' | translate }} </button>
      
      <!-- Delete project-->
      <button mat-raised-button class="ml-1" color="warn" (click)="nuke()">{{ 'PROJECT.DELETE.TITLE' | translate }} </button>
    </div>

    <!--
    <mat-divider class="mt-2 mb-2"></mat-divider>
    <h6 class="primary pt-2"> {{'PROJECT.SETTING.CLIP_VOLUME' | translate }}  </h6>
    <mat-form-field class="mt-2" >
      <mat-select [(ngModel)]="defaultAnnotation" style="font-size: 16px;" [placeholder]="'PROJECT.SETTING.CLIP_VOLUME' | translate" >
        <mat-option *ngFor="let aa of annotation" [value]="aa" >
          {{aa.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div>
      <button mat-raised-button class="ml-1" color="primary" (click)="clip()">
        <fa-icon icon="cut" ></fa-icon>
      </button>
      <button mat-raised-button class="ml-1" color="warn" (click)="clearAllClipPlanes(false)">
        <fa-icon icon="backspace" ></fa-icon>
      </button>
    </div>
  </div>
-->
<!--
<div id="container" style="font-size: 14px"  class="p-2" *ngIf="!loading" >

  <input type="text" class="heading_text primary w-90 pt-2"
        [(ngModel)]="project.name" />
  <div id="first">
    {{ 'PROJECT.SETTING.MEASUREMENT_UNIT' | translate }} :
  <mat-radio-group (change)="saveMeasurementUnit()" [(ngModel)]="feet_Meter">
    <mat-radio-button [value]="Feet">{{ 'PROJECT.SETTING.FEET' | translate }}</mat-radio-button>
    <mat-radio-button [value]="Meter">{{ 'PROJECT.SETTING.METER' | translate }}</mat-radio-button>
  </mat-radio-group>

  <div class="m-2">
    <span *ngIf="selectedEPSGCode">{{'MAP.PHOTOGRAM.SELECTED_EPSG_CODE' | translate }} {{selectedEPSGCode.name}} </span> <br>
    <button mat-stroked-button class="mt-2 ml-2 stroke-button"  (click)="selectEPSGCode()" > {{'MAP.PHOTOGRAM.SELECT_EPSG_CODE' | translate }} </button>
  </div>
 </div>

<div>
  <mat-slide-toggle class="mt-2 ml-2" (change)="showBaseModel($event)" [(checked)]="baseModel">{{ 'MAP.BACKGROUND_MAP' | translate }}</mat-slide-toggle>
</div>
  <div class="mt-2 ml-2">
    <mat-checkbox   [(ngModel)]="resetLastLocation">Reset Last Saved Location</mat-checkbox>
  </div>
<div>
  <button mat-raised-button class="ml-1" color="primary" (click)="save()">{{ 'GENERIC.SAVE' | translate }} </button>
  <button mat-raised-button class="ml-1" color="warn" (click)="nuke()">{{ 'PROJECT.DELETE.TITLE' | translate }} </button>
</div>


<mat-divider class="mt-2 mb-2"></mat-divider>
<h6 class="primary pt-2"> {{'PROJECT.SETTING.CLIP_VOLUME' | translate }}  </h6>

<mat-form-field class="mt-2" >
  <mat-select [(ngModel)]="defaultAnnotation" style="font-size: 16px; !important;" [placeholder]="'PROJECT.SETTING.CLIP_VOLUME' | translate" >
    <mat-option *ngFor="let aa of annotation" [value]="aa" >
      {{aa.name}}
    </mat-option>
  </mat-select>
</mat-form-field>
<div>
  <button mat-raised-button class="ml-1" color="primary" (click)="clip()">
    <fa-icon icon="cut" ></fa-icon>
  </button>
  <button mat-raised-button class="ml-1" color="warn" (click)="clearAllClipPlanes(false)">
    <fa-icon icon="backspace" ></fa-icon>
    </button>
  </div>

</div>
-->
